<template>
  <div v-if="row.length" class="row" :class="groupReadOnly ? 'flex-start' : 'flex-end'">
    <form-field-store-wrapper
      v-for="(field, fieldIndex) in row"
      :key="field.id"
      :path="`${path}/${fieldIndex}`"
      :group-read-only="groupReadOnly"
      :type="field.type"
    />
  </div>
</template>

<script>
import FormFieldStoreWrapper from './FormFieldStoreWrapper.vue'

export default {
  name: 'FormGroupRow',
  components: {
    FormFieldStoreWrapper,
  },
  props: {
    path: {
      type: String,
    },
    groupReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    row() {
      return this.$get('rowByPath')(this.path)
    },
  },
}
</script>
